/// <reference path="../../../../turbo/views/login/login.component.ts" />
import { Component, ElementRef, OnInit } from '@angular/core';
import { PageBase } from 't4core';


@Component({
    selector: 'notifications',
    templateUrl: './notifications.html',
    styleUrls: ['./notifications.css'],
})
export class NotificationsComponent extends PageBase implements OnInit {

    constructor(el: ElementRef) {
        super(el, "Messages");

    }

    ngOnInit() {
        
    }
}
